import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updatePurchaseOrderApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const updatePurchaseOrder = createAsyncThunk('updatePurchaseOrder', async (payload) => {
  return await updatePurchaseOrderApi(payload);
});

const updatePurchaseOrderSlice = createSlice({
  name: 'updatePurchaseOrder', // Unique Name
  initialState,
  reducers: {
    updatePurchaseOrderReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updatePurchaseOrder.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(updatePurchaseOrder.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(updatePurchaseOrder.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { updatePurchaseOrderReset } = updatePurchaseOrderSlice.actions;

export default updatePurchaseOrderSlice.reducer;
